import styles from './Navbar.module.css';
import { Link } from 'react-scroll'
import { useState } from 'react';
import { BorderAll } from '@material-ui/icons';

export function Navbar() {
    const [barDisplay, setBarDisplay] = useState("flex");
    const [crossDisplay, setCrossDisplay] = useState("none")

    return (
        <div className={styles.container} id="nav-menu">
            <nav className={styles.navBar}>
                <ul>
                    <li width={"100%"}><Link
                        onClick={() => { setBarDisplay("flex"); setCrossDisplay("none") }}
                        activeClass="active"
                        to="home"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >{"Mehul"}</Link></li>
                </ul>
                <ul>
                    <li class="nav-link home"><Link
                        activeClass="active"
                        to="home"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >Home</Link></li>
                    <li class="nav-link about"><Link
                        activeClass="active"
                        to="#about"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >About</Link></li>
                    <li class="nav-link skills"><Link
                        activeClass="active"
                        to="skills"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >Skills</Link></li>
                    <li class="nav-link projects"><Link
                        activeClass="active"
                        to="projects"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >Projects</Link></li>
                    <li class="nav-link contact"><Link
                        activeClass="active"
                        to="contact"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >Contact</Link></li>
                    <li class="nav-link resume">
                        <button id="resume-button-1" style={{background:"cyan", border:"none", borderRadius:"5px"}}><a
                        id="resume-link-1"
                        href={"./Kanjariya-Mehul-Kumar-Resume.pdf"}
                        download
                        onClick={()=>window.open("https://drive.google.com/file/d/1Jl0rrOTxr3cPVZteR_TIWVdVXadnv8HS/view?usp=share_link")}
                        target="_blank"
                        rel="noreferrer"
                        style={{fontSize:"14px", fontWeight:"200", color:"black"}}
                    >Resume</a></button></li>
                </ul>
                <ul>
                    <li style={{ display: `${barDisplay}` }} onClick={() => { setCrossDisplay("flex"); setBarDisplay("none") }}><i className="fas fa-bars"></i></li>
                    <li style={{ display: `${crossDisplay}` }} onClick={() => { setBarDisplay("flex"); setCrossDisplay("none") }}><i className="fas fa-times"></i></li>
                </ul>
            </nav>
            <div className={styles.dropdown} style={{display: `${(crossDisplay === "flex") ? "inherit" : "none"}`}}>
                <ul>
                <li><Link
                        onClick={() => { setBarDisplay("flex"); setCrossDisplay("none") }}
                        activeClass="active"
                        to="home"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >Home</Link></li>
                    <li><Link
                        onClick={() => { setBarDisplay("flex"); setCrossDisplay("none") }}
                        activeClass="active"
                        to="#about"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >About</Link></li>
                    <li><Link
                        onClick={() => { setBarDisplay("flex"); setCrossDisplay("none") }}
                        activeClass="active"
                        to="skills"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >Skills</Link></li>
                    <li><Link
                        onClick={() => { setBarDisplay("flex"); setCrossDisplay("none") }}
                        activeClass="active"
                        to="projects"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >Projects</Link></li>
                    <li><Link
                        onClick={() => { setBarDisplay("flex"); setCrossDisplay("none") }}
                        activeClass="active"
                        to="contact"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                    >Contact</Link></li>
                    <li><a
                        href={"./Fw21_0298-Kanjariya-Mehul-Kumar-Resume.pdf"}
                        download
                        onClick={()=>window.open("https://drive.google.com/file/d/1Jl0rrOTxr3cPVZteR_TIWVdVXadnv8HS/view?usp=share_link")}
                        target="_blank"
                        rel="noreferrer"
                    >Resume</a></li>
                </ul>
            </div>
        </div>
    );
}